angular.module('rjmNg.api').factory("CurrencyConverterDefinition", [
  'BaseDefinition'
  (BaseDefinition) ->

    class CurrencyConverterDefinition extends BaseDefinition

      @definition: 'currency_converter'
      @category: 'sameTable'
      @arg: 'column'
      @subtypes: [
          symbol: 'CURRENCY_CONVERTER'
          description: 'A calculation that converts the native currency of a column to a desired currency.'
          typeFilter: [
            'decimal'
          ]
      ]
      @filtersSupported: false

      @fromColumn: (structure, column) ->
        result = super structure, column, @definition
        result.properties = {}

        columnId = column.properties.source_column_id
        tableId = structure.columns[columnId].table_id

        result.properties.source_column =
          column: column.properties.source_column_id
          table: tableId
        result.properties.timestamp_column =
          column: column.properties.timestamp_column_id
          table: tableId
        result.properties.start_currency_column =
          column: column.properties.start_currency_column_id
          table: tableId
        result.properties.target_currency = column.currency_code

        return result

      @toColumn: (structure, table, field) ->
        result = super structure, table, field

        result.field_type = 'value_currency'
        result.old_data_type = 'DECIMAL'
        result.currency_code = field.properties.target_currency

        # copy currency / decimal data from source column
        angular.extend(result.data_type,
          structure.columns[field.properties.source_column.column].data_type
        )

        angular.extend(result.properties,
          derivative_type: 'currency_converter'
          source_column_id: field.properties.source_column.column
          timestamp_column_id: field.properties.timestamp_column.column
          start_currency_column_id: field.properties.start_currency_column.column
        )

        return result

      @validateField: (column) ->
        super?.validateField(column)
        unless column.properties.source_column.column? \
          and column.properties.source_column.column isnt 0 \
          and column.properties.target_currency? \
          and column.properties.target_currency isnt null \
          and column.properties.timestamp_column.column? \
          and column.properties.timestamp_column.column isnt 0 \
          and column.properties.start_currency_column.column? \
          and column.properties.start_currency_column.column isnt 0
            throw "You need to select all columns and target currency."
  ]
)

